import type { HelperResult, JobSearchArea } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useJobSearchAreas, useUpdate: useUpdateJobSearchAreas } =
  getCRUDHooks<JobSearchArea>({
    entityName: 'userJobSearchAreas',
    find: ({ userId }: { userId?: number }) => {
      if (userId) {
        return clientApi.getOCClient().helpers.user.users.getJobSearchAreas(userId);
      }

      return clientApi.getOCClient().helpers.user.me.getJobSearchAreas();
    },
    update: (
      jobSearchAreas: JobSearchArea[],
      { userId, context }: { userId?: number; context: string }
    ): HelperResult<JobSearchArea[]> => {
      if (userId) {
        return clientApi
          .getOCClient()
          .helpers.user.users.updateJobSearchAreas(userId, jobSearchAreas, { context });
      }

      return clientApi
        .getOCClient()
        .helpers.user.me.updateJobSearchAreas(jobSearchAreas, { context });
    },
  });

export { useJobSearchAreas, useUpdateJobSearchAreas };
